import React, { FC } from 'react';

import { SvgIcon } from '@mui/material';

import { ICON_SIZE_SM } from 'constants/common';

export type SaveIconProps = {
  size?: string | number;
  color?: string;
};

export const SaveIcon: FC<SaveIconProps> = ({
  size = ICON_SIZE_SM,
  color = 'currentColor',
}) => (
  <SvgIcon
    viewBox="0 0 24 24"
    focusable="false"
    aria-hidden="true"
    sx={{ width: size, height: size, fill: 'none', flexShrink: 0 }}
  >
    <path
      d="M2 5a3 3 0 0 1 3-3h11.17c.53 0 1.04.21 1.41.59l3.83 3.83c.38.38.59.88.59 1.41V19a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V5Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      opacity="0.4"
      d="M7.5 2v4.5c0 .83.67 1.5 1.5 1.5h4c.83 0 1.5-.67 1.5-1.5V2"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      opacity="0.4"
      d="M17.5 22v-5c0-1.1-.9-2-2-2h-7c-1.1 0-2 .9-2 2v5"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
);
